export default (messages, indexes) => {
  console.log('messages :>> ', messages);
  console.log('indexes :>> ', indexes);
  const { message_index, row_index, component_index } = indexes
  
  const editedCurrentEditMessage = messages.map((msg, msg_i) => {
    const { rows } = msg

    if (msg_i === message_index) {
      return {
        ...msg,
        rows: rows.map((row, row_i) => {
          const { components } = row
            
          if (row_i+1 === row_index) {
            const copiedComponents = (() => {
              const newComponents = []
              for (let index=0 ; index < components.length ; index++ ) {
                const component = components[index]
                newComponents.push(component)
                if (index === component_index) {
                  newComponents.push(component)
                }
              }
              return newComponents
            })()
  
            return {
              ...row,
              components: copiedComponents,
            }
          }

          return row
        })
      }
    }

    return msg
  })

  return editedCurrentEditMessage
}